import { Injectable } from '@angular/core';

@Injectable()
export class CookieHelperService {

  public get isClassic():boolean {
    return this._getCookie("isClassic");
  }

  constructor() { }

  _setCookie(name: string, value: any, expiredDate?: any): void {
    const _monthExpires = new Date(new Date().getTime() + 30 * 1000 * 60 * 60 * 24);

    // if expiredDate is not given, set to default 30 days expiration
    const _expiredDate = expiredDate ? expiredDate : _monthExpires.toUTCString();

    // document.cookie = name + '=' + value + '; expires=' + _expiredDate + '; path=/';
    document.cookie = name + '=' + value + '; path=/';
  }

  _getCookie(name: string): any {

    const _name:       string = name + '=';
    const _cookies:    Array<any> = document.cookie.split(';');
    let _returnCookie: any;
    let _json_str:     string;

    for (let i = 0; i < _cookies.length; i++) {

        let _cookie = _cookies[i];

        while (_cookie.charAt(0) === ' ') {

          _cookie = _cookie.substring(1);

        }

        if (_cookie.indexOf(_name) === 0) {

          _json_str = _cookie.substring(_name.length, _cookie.length);

        }
    }

    if (_json_str !== null && _json_str !== undefined && this._isValidJSONstring(_json_str)) {
      _returnCookie = JSON.parse(_json_str);

      if (typeof _returnCookie === 'string') {
        _returnCookie = _json_str;
      }
    } else {
      _returnCookie = _json_str;
    }

    return _returnCookie;
  }

  _removeCookie(name): void {

    this._setCookie(name, null, -1);

  }
  /**
   * @param str: string: JSON string
   * @return isValid: boolean - determines if valid JSON
   */
  _isValidJSONstring(str): boolean {

    let _isValid: boolean;

    try {

      JSON.parse(str);
      _isValid = true;

    } catch (e) {

      _isValid = false;

    }

    return _isValid;
  }

  /**
   *
   * @param name key for the object
   * @param value value
   *
   * Stores variable on session
   * @todo to check in ie if it is working
   */
  saveOnSession(name: string, value: string): void {
    // Check if Storage is supported
    if (typeof(Storage) !== 'undefined') {
        // Store
        localStorage.setItem(name, value);
    } else {
        // Sorry! No Web Storage support..
        console.log('No Storage');
    }
  }

  getOnSession(name: string): any {
    // Check if Storage is supported
    if (typeof(Storage) !== 'undefined') {
      // Store
      return localStorage.getItem(name);
    } else {
      // Sorry! No Web Storage support..
      console.log('No Storage');
      return null;
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/shared/services/cookie-helper.service.ts